















import { Component, Prop, Vue } from "vue-property-decorator";
import HomeSection from "../home/HomeSection.vue";
import CzIcon from "./CzIcon.vue";
import CzTitle from "./CzTitle.vue";

@Component({ components: { HomeSection, CzIcon, CzTitle } })
export default class CzPage extends Vue {
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: [String, Object], default: "" }) backTo!: string | object;
  @Prop({ type: String, default: "" }) backLabel!: string;
  @Prop({ type: String, default: "" }) empty!: string;
  @Prop({ type: Boolean, default: false }) center!: boolean;
}
